"use strict";
'use es6'; // Stolen from enviro. wanted to remove deps

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var qaRegex = /(?:hubspot|hubteam|grader|getsignals|getsidekick|gettally|leadin|hubspotemail|customer-hub|hubspotservicehub)qa\.com|(?:hubspotstarter|hubspotfree)qa\.net|(?:growth)qa\.org/;

var isProd = function isProd() {
  return !qaRegex.test(document.location.host);
};

var _default = {
  isProd: isProd
};
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/self-service-api/static-1.1360/js/core/utilities/enviro.js
// module id = 182
// module chunks = 5 6 7